<mat-select
  [class]="'pr-button ' + clazz + ' ' + display"
  (selectionChange)="change($event)"
  [(ngModel)]="value"
  [placeholder]="placeholder"
  [disabled]="disabled"
>
  @for (option of currentOptions; track trackByValue($index, option)) {
    <mat-option [value]="option.value">
      {{ option.label }}
    </mat-option>
  }
</mat-select>
